'use client'
// NOTE: 'use client' prevents the following
// "Warning: Only plain objects can be passed to Client Components from Server Components. Classes or other objects with methods are not supported"
// We're passing down style object with assignInlineVars
import { type ComponentProps, forwardRef } from 'react'
import { clsx } from 'clsx'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { iconRoot, iconSize, rotateIcon } from './Root.css'

export type IconRootProps = ComponentProps<'svg'> & {
  color?: string
  size?: string
  direction?: 'up' | 'down' | 'left' | 'right'
}

export const IconRoot = forwardRef<SVGSVGElement, IconRootProps>(
  ({ className, style, size, color, direction, ...props }, ref) => (
    <svg
      ref={ref}
      className={clsx(iconRoot, direction && rotateIcon[direction], className)}
      style={{
        ...assignInlineVars({
          [iconSize]: size,
        }),
        color,
        ...style,
      }}
      {...props}
    />
  ),
)
IconRoot.displayName = 'IconRoot'
